import React, { useCallback, useRef, useState, useEffect } from 'react';

import { Input, InputNumber } from 'antd';
import { debounce } from 'underscore';
import styled from 'styled-components';

import { EditableInputContainer } from '../styles';

const EditableNumberInputContainer = styled.div`
  .ant-input-number {
    .ant-input-number-handler-wrap {
      display: ${({ hideStepButtons }) => (hideStepButtons ? 'none' : '')};
    }
  }
`;

export const EditableCell = ({
  record,
  text,
  id,
  updateSource,
  type = 'text',
  updateType = 'onChange',
  isPreview = false,
  ...extraProps
}) => {
  const [isEditMode, setEditMode] = useState(false);
  const [content, setContent] = useState(text);
  const inputRef = useRef();
  const valueRef = useRef();

  useEffect(() => {
    if (type === 'number') {
      if (text !== valueRef.current) {
        setContent(text);
        valueRef.current = text;
      }
    }
  }, [text, type]);

  const debouncedUpdateSource = useCallback(debounce(updateSource, 300), [updateSource]);

  const handleChange = event => {
    setContent(event.target.value);
    debouncedUpdateSource(record, id, event.target.value);
  };

  const handleNumberChange = e => {
    const value = e?.target ? (e.target.value ? Number(e.target.value) : e.target.value) : e;
    setContent(value);
    valueRef.current = value;
    debouncedUpdateSource(record, id, value);
  };

  if (type === 'number') {
    const changeProps = {
      [updateType]: handleNumberChange,
    };
    return (
      <EditableNumberInputContainer hideStepButtons={updateType === 'onPressEnter'}>
        <InputNumber
          onClick={() => setEditMode(true)}
          ref={inputRef}
          type={type}
          value={content}
          onBlur={() => setEditMode(false)}
          style={{ zIndex: isPreview ? 0 : (isEditMode ? 3 : 1) }}
          {...changeProps}
          {...extraProps}
        />
      </EditableNumberInputContainer>
    );
  }

  return (
    <EditableInputContainer id={id}>
      <Input
        onClick={() => setEditMode(true)}
        ref={inputRef}
        type={type}
        value={content}
        onChange={handleChange}
        onBlur={() => setEditMode(false)}
        style={{ zIndex: isPreview ? 0 : (isEditMode ? 3 : 1) }}
      />
    </EditableInputContainer>
  );
};
